<div class="sidenav-content" @routeAnimation>
	<copo-panel-header [titleHeaderText]="'auction.dashboard' | translate" (backButtonClick)="goBack()"></copo-panel-header>
	<div class="copo-container grid-6 footer-margin">
		<copo-auction-overview class="card-block"></copo-auction-overview>
	</div>
</div>
